var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GridPage',{ref:"gridPage",attrs:{"form-default":{
            name: '',
            hs_code: '',
            country: '',
        },"filters-default":{
            sort: 'name',
        },"filter-items":[
            {
                vModel: 'sort',
                title: '順番',
                options: [
                    { text: '▲ 名前', value: 'name', },
                    { text: '▼ 名前', value: '-name' },
                    { text: '▲ 単価', value: 'price', },
                    { text: '▼ 単価', value: '-price' } ],
            } ],"filters-q-placeholder":"保存名、HSコード","form-modal-id":"shipping_hscode","search-action":"shipping_hscode/index","item-id":"id"},on:{"after-save":_vm.onAfterSave},scopedSlots:_vm._u([{key:"form",fn:function(ref){
        var form = ref.form;
        var init = ref.init;
return [_c('ShippingHscode',{attrs:{"model":form,"init":init}})]}},{key:"column",fn:function(ref){
        var item = ref.item;
return [_c('b-col',{staticClass:"align-self-center",attrs:{"md":"6"}},[_c('p',{staticClass:"mb-1"},[(item.is_default)?_c('span',[_vm._v("\n                        ※初期値\n                    ")]):_vm._e()]),_vm._v(" "),(item.name)?_c('p',[_vm._v("\n                    "+_vm._s(item.name)+"\n                ")]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"align-self-center",attrs:{"md":"6"}},[(item.hs_code)?_c('div',[_vm._v("\n                    HSコード："+_vm._s(item.hs_code)+"\n                ")]):_vm._e(),_vm._v(" "),(item.country)?_c('div',[_vm._v("\n                    原産国："+_vm._s(item.country)+"\n                ")]):_vm._e()])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }